import { helper } from '@ember/component/helper';
import { ButtonDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
function getButtonStyles([buttonStyle]) {
  switch (buttonStyle) {
    case ButtonDescription.ButtonStyle.BUTTON_STYLE_PRIMARY:
      return 'primary';
    case ButtonDescription.ButtonStyle.BUTTON_STYLE_SECONDARY:
      return 'secondary';
    case ButtonDescription.ButtonStyle.BUTTON_STYLE_TERTIARY:
      return 'tertiary';
    case ButtonDescription.ButtonVariant.BUTTON_VARIANT_DESTRUCTIVE:
      return 'destructive';
    case ButtonDescription.ButtonVariant.BUTTON_VARIANT_NORMAL:
      return 'regular';
    default:
      return '';
  }
}
export default helper(getButtonStyles);